import {
  addMessage,
  updateMessageStatus,
} from "./components/features/whatsapp-chat/whatsappChat.js";
import {
  incrementUnread,
  updateLatestMessage,
  updateLatestMessageStatus,
} from "./components/features/whatsapp-contacts/whatsappContacts.js";
import { format } from "date-fns";

export function handleFcmData(dispatch, data) {
  let contactId = Number(data.contact);
  switch (data.update) {
    case "message_received":
      dispatch(
        addMessage({
          contactId,
          message: {
            id: data.id,
            message_id: data.message_id,
            user_id: data.user_id,
            message: data.message,
            status: data.status,
            created_at: data.created_at,
            contact: data.contact,
            phone_number_id: data.phone_number_id,
          },
        })
      );
      dispatch(
        updateLatestMessage({
          contactId,
          latestMessage: {
            message: data.message,
            status: data.status,
            datetime: format(
              new Date(data.created_at),
              "dd-MM-yyyy hh:mm:ss a"
            ),
          },
        })
      );
      dispatch(incrementUnread(contactId));
      break;

    case "message_status":
      dispatch(
        updateMessageStatus({
          contactId: data.contact_id,
          messageId: data.message_id,
          status: data.status,
        })
      );
      dispatch(
        updateLatestMessageStatus({
          contactId,
          status: data.status,
        })
      );
      break;

    default:
      console.warn("Unhandled FCM update type:", data.update);
  }
}
